import { Coins, Instagram, MessageCircle, Youtube, Heart } from 'lucide-react';

export function Footer() {
  return (
    <footer className="border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-950 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            {/* Bitcoin Life Panamá Logo */}
            <div className="w-10 h-10 rounded-lg overflow-hidden flex items-center justify-center bg-white p-1">
              <img src="/logo.jpg" alt="Bitcoin Life Panamá Logo" className="w-full h-full object-contain" />
            </div>
            <span className="font-bold text-lg">Bitcoin Life Panamá</span>
          </div>
          <p className="text-muted-foreground mb-6">
            Construyendo economía circular en Ciudad de Panamá • Orange-pilling el país
          </p>

          {/* Social Links */}
          <div className="space-y-6 mb-8">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Conéctate con Nosotros
            </h3>
            
            {/* Primary Social Links */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://www.instagram.com/bitcoinlifepanama/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-white hover:shadow-lg hover:scale-105 transition-all duration-300 group"
              >
                <Instagram className="w-5 h-5 group-hover:rotate-12 transition-transform" />
                <span className="font-medium">Instagram</span>
              </a>
              
              <a
                href="https://chat.whatsapp.com/L9sHakI1ESZ0m1DdeX2qtM"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:shadow-lg hover:scale-105 transition-all duration-300 group"
              >
                <MessageCircle className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span className="font-medium">WhatsApp</span>
              </a>
            </div>

            {/* Secondary Social Links - Icon Grid */}
            <div className="flex items-center justify-center gap-3">
              <a
                href="https://www.tiktok.com/@bitcoinlifepanama"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative"
                title="TikTok"
              >
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gray-900 to-gray-700 dark:from-gray-800 dark:to-gray-600 flex items-center justify-center hover:shadow-lg hover:scale-110 transition-all duration-300">
                  <svg className="w-6 h-6 text-white group-hover:scale-110 transition-transform" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                </div>
              </a>

              <a
                href="https://www.youtube.com/MuzziliYT"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative"
                title="YouTube"
              >
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-600 to-red-500 flex items-center justify-center hover:shadow-lg hover:scale-110 transition-all duration-300">
                  <Youtube className="w-6 h-6 text-white group-hover:scale-110 transition-transform" />
                </div>
              </a>

              <a
                href="https://x.com/BTClifePanama"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative"
                title="X (Twitter)"
              >
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gray-900 to-black dark:from-gray-800 dark:to-gray-900 flex items-center justify-center hover:shadow-lg hover:scale-110 transition-all duration-300">
                  <svg className="w-5 h-5 text-white group-hover:scale-110 transition-transform" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </div>
              </a>

              <a
                href="https://geyser.fund/project/bitcoinlifepanama"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative"
                title="Geyser Fund - Apóyanos"
              >
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-600 to-orange-500 flex items-center justify-center hover:shadow-lg hover:scale-110 transition-all duration-300">
                  <Heart className="w-6 h-6 text-white group-hover:scale-110 transition-transform fill-white" />
                </div>
              </a>
            </div>
          </div>

          <p className="text-sm text-muted-foreground">
            Creado con{' '}
            <a
              href="https://soapbox.pub/mkstack"
              target="_blank"
              rel="noopener noreferrer"
              className="text-orange-600 hover:text-orange-700 dark:text-orange-400 dark:hover:text-orange-300 underline"
            >
              MKStack
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
